import React from 'react';
import FeatureWrapper from './MobileViewWrapper/FeatureWrapper';
import Wrapper from './MobileViewWrapper/Wrapper';

const ProductCardMobileView = ({ index, product }) => {
	const showFeaturedProduct = index === 0 && product.IsFeaturedProduct;

	return showFeaturedProduct ? (
		<FeatureWrapper {...{ product, index }} />
	) : (
		<Wrapper {...{ product, index }} />
	);
};

export default ProductCardMobileView;
